/** @jsx dom */
import debounce from 'debounce';
import dom from 'magic-virtual-element';
import {utils as cmsUtils} from '@viskan/cms-components';
import page from 'page';

const defaultProps = {
	addons: [],
	articleIsLoaded: true,
	isInStock: true,
	itemType: 'article',
	quantity: 1
};

const itemIdField = {
	article: 'art_id',
	subscription: 'prentype_id'
};

const render = ({props}) => {
	const {hideOutOfStockButton, outOfStockMessage, closePopup, popupIsOpen} = props;
	const inStock = props.isInStock;
	const styles = {
		cursor: inStock ? 'pointer' : 'not-allowed'
	};

	if (!props.articleIsLoaded) {
		return <noscript/>;
	}

	if (hideOutOfStockButton && !inStock) {
		return cmsUtils.createCmsComponent((
			<div class={['CMS-Article-outOfStockMessage', props.class, props.styleClasses.Container]} data-style-attr='Container'>
				{outOfStockMessage}
			</div>
		), props);
	}

	const onClick = inStock && (() => {
		const item = !props.itemId ? props.article : {
			[itemIdField[props.itemType]]: parseInt(props.itemId, 10)
		};

		const sku = !props.itemId ? props.active : {
			attr1_id: props.attr1_id,
			attr2_id: props.attr2_id,
			attr3_id: props.attr3_id
		};
		const actions = {
			article: () => props.addArticle(item, sku, props.addons, props.quantity),
			subscription: () => props.addSubscription(item)
		};

		return actions[props.itemType]().then(() => {
			if (popupIsOpen) {
				closePopup();
			}

			if (props.goToCheckout) {
				page('/checkout');
			}
		});
	});

	if (props.children && props.children.length > 0) {
		return cmsUtils.createCmsComponent((
			<div class='CMS-Article-buyButton--parent' onClick={debounce(onClick, 1000, true)}>
				{props.children}
			</div>
		), props);
	}

	return cmsUtils.createCmsComponent((
		<button class={['CMS-Article-buyButton', props.class, props.styleClasses.Button]} style={styles} disabled={!inStock} onClick={debounce(onClick, 1000, true)} data-style-attr='Button'>
			{inStock ? props.buttonText : props.outOfStockButtonText}
		</button>
	), props);
};

export default {defaultProps, render};
